module.exports = __webpack_public_path__ + "static/media/option8-4row.5e5cc693.png";